mutation office365SetInitialSyncSettings($input: Office365SetInitialSyncSettingsInput!) {
    office365SetInitialSyncSettings(input: $input) {
        success
        errorMessage
    }
}
